import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/Footer.css';
import logo from '../assets/images/logo.png';
import logo2 from '../assets/images/logo2.png';

const Footer = () => {
  const { isDarkMode } = useTheme();

  return (
    <footer className={`footer ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="footer-container">
        <div className="footer-content">
          {/* Pages Section */}
          <div className="footer-section">
            <h3>Sayfalar</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Ana Sayfa</Link>
              </li>
              <li>
                <Link to="/hakkimizda">Hakkımızda</Link>
              </li>
              <li>
                <Link to="/iletisim">İletişim</Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer-section">
            <h3>İletişim Bilgilerimiz</h3>
            <div className="contact-info">
              <div className="contact-item">
                <strong>Şube 1:</strong>
                <span>Gazi Cad. Tarihi Kuyumcular Çarşısı No: 25 Sur/D.BAKIR</span>
              </div>
              <div className="contact-item">
                <strong>Şube 2:</strong>
                <span>Gazi Cad. Hasanpaşa Hanı Altı No: D Sur/D.BAKIR</span>
              </div>
              <div className="contact-item">
                <strong>Şube 3:</strong>
                <span>Mahabad Bulvarı 75 Yol Üzeri No: 69 Kayapınar/D.BAKIR</span>
              </div>
              <div className="contact-item">
                <strong>Telefon:</strong>
                <span>0412 330 01 21</span>
              </div>
              <div className="contact-item">
                <strong>E-posta:</strong>
                <span>info@engkiymetlimadenler.com</span>
              </div>
            </div>
          </div>

          {/* Company Logo Section */}
          <div className="footer-section logo-section">
            <div className="company-logo">
              <div className="logo-image">
                <img 
                  src={isDarkMode ? logo  : logo2} 
                  alt="AIFASOFT" 
                  className="logo-img"
                />
              </div>
            </div>
            <p className="company-description">
              Güvenilir kıymetli maden ve döviz işlemleri için doğru adres
            </p>
            
            {/* Google Maps */}
            <div className="map-container">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3147.7637446800245!2d40.234423276335484!3d37.91258455420885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x407520387420481b%3A0x85a92495f6aa5fc3!2zS3V5dW1jdWxhciDDh2FyxZ_EsXPEsQ!5e0!3m2!1str!2str!4v1755528455020!5m2!1str!2str" 
                width="100%" 
                height="200" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Mağaza Konumu"
                className="footer-map"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 AIFASOFT. Tüm hakları saklıdır.</p>
            <div className="footer-bottom-links">
              <button className="footer-link-btn">Gizlilik Politikası</button>
              <button className="footer-link-btn">Kullanım Şartları</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
